import * as React from "react";

const Cloud = (props: any) => (
  <svg width={35} height={24} viewBox="0 0 35 24" {...props}>
    <path
      d="M28.827 8.505a6.787 6.787 0 0 0-.577-.09l-.11-.017a7.19 7.19 0 0 0-.728-.04l-.015.001-.033-.001c-.253 0-.502.014-.749.039-.878-2.938-3.546-5.026-6.641-5.026-.34 0-.802.028-1.23.079C17.224 1.36 14.799 0 12.057 0 7.45 0 3.714 3.824 3.714 8.542c0 .19.017.375.028.56A8.081 8.081 0 0 0 0 15.95C0 20.39 3.513 23.99 7.847 24h18.94l-.005-.03c.193.015.386.03.581.03C31.582 24 35 20.499 35 16.179c0-3.807-2.655-6.975-6.173-7.674z"
      fill="#FFF"
      fillRule="nonzero"
    />
  </svg>
);

export default Cloud;

